import BaseForm from '../base';
import { LatLongColumnsComponent, TwoColumnsComponent } from '../components';
const AUTHENTICATION_DESC = '<details>' +
    '<summary class="cursor-pointer" style="display:list-item">' +
    'Select how the controller will authenticate access.</summary>' +
    '<code>Facility + Card</code> grants access to specific cards<br>' +
    '<code>Facility Code Only</code> grants access to a batch of cards via Facility Code ' +
    '(provided with batch of cards)<br>' +
    '<code>Pin Only</code> grants access when a valid pin is entered<br>' +
    '<code>Card</code> grants access to specific cards. Choose this option only if you do not know the facility code ' +
    'for a batch of cards.<br>' +
    '<code>Card Hex</code> grants access based on a supplied hex string (UNUSED)<br>' +
    '<code>PIN then Card</code> and <code>Card then PIN</code> Dual-factor authentication: grant access when ' +
    'a valid PIN and associated Card are entered in the correct order.</details>';
export class AccessControlsForm extends BaseForm {
    constructor(...args) {
        super(...args);
        this.components = [
            new LatLongColumnsComponent({ validate: { required: true } }),
            {
                label: 'Timezone',
                key: 'timezone',
                type: 'select-timezone',
            },
            {
                label: 'Local IP',
                key: 'ip',
                type: 'textfield',
            }, new TwoColumnsComponent({ key: 'credentials' }, {
                label: 'Username',
                key: 'username',
                type: 'textfield',
            }, {
                label: 'Password',
                key: 'password',
                type: 'customPassword'
            }),
            {
                label: 'Authentication Methods',
                key: 'authentication',
                type: 'select',
                multiple: true,
                defaultValue: [
                    'Facility Code + Card',
                    'Pin Only'
                ],
                description: AUTHENTICATION_DESC,
                data: {
                    values: [
                        {
                            label: 'Facility Code',
                            value: 'Facility Code'
                        },
                        {
                            label: 'Pin Only',
                            value: 'Pin Only'
                        },
                        {
                            label: 'Facility Code + Card',
                            value: 'Facility Code + Card'
                        },
                        {
                            label: 'Card',
                            value: 'Card'
                        },
                        {
                            label: 'Card Hex',
                            value: 'Card Hex'
                        },
                        {
                            label: 'PIN then Card',
                            value: 'PIN then Card'
                        },
                        {
                            label: 'Card then PIN',
                            value: 'Card then PIN',
                        },
                    ]
                },
            },
        ];
    }
}
